// Player do YouTube (não listado) com a lista de capítulos clicável. Usado no
// modal da Central e no painel "Como usar esta tela". Trocar o capítulo recria
// o iframe no `start` pedido (sem a API JS do YouTube).
// Sem `?.`/`??`: o build roda em CRA 3.4 / Node 12.
import React, { useEffect, useState } from "react";

import { embedYoutube, formatarDuracao } from "./rotas";

export default function Player({ youtubeId, inicioSegundos, capitulos, titulo, mostrarCapitulos = true }) {
  const [inicio, setInicio] = useState(Math.max(0, Number(inicioSegundos) || 0));

  useEffect(() => {
    setInicio(Math.max(0, Number(inicioSegundos) || 0));
  }, [inicioSegundos, youtubeId]);

  if (!youtubeId) return null;
  const lista = (Array.isArray(capitulos) ? capitulos : []).filter((c) => c && Number.isFinite(Number(c.s)));
  // O capítulo "ativo" é o último cujo início é <= ao start atual.
  let ativo = -1;
  lista.forEach((c, i) => {
    if (Number(c.s) <= inicio) ativo = i;
  });

  return (
    <div className="treinamento-player-wrap">
      <div className="treinamento-player">
        <iframe
          key={`${youtubeId}-${inicio}`}
          src={embedYoutube(youtubeId, inicio)}
          title={titulo || "Vídeo do tutorial"}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          data-testid="treinamento-iframe"
        />
      </div>
      {mostrarCapitulos && lista.length > 0 ? (
        <ul className="treinamento-capitulos" aria-label="Capítulos">
          {lista.map((c, i) => (
            <li key={`${c.s}-${i}`}>
              <button type="button" className={i === ativo ? "is-active" : ""} onClick={() => setInicio(Math.max(0, Number(c.s) || 0))}>
                <span className="tempo">{formatarDuracao(c.s) || "0:00"}</span>
                <span>{c.titulo}</span>
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
